export const fics = [
    {
        _id: "fic-1",
        name: "Nirmal K. Rout",
        domain: "Professor",
        photo: "https://i.imgur.com/D1DH7gu.png",
        email: "nkrout@kiit.ac.in",
    },
    {
        _id: "fic-2",
        name: "Tejaswini Kar",
        domain: "Assistant Professor",
        photo: "https://i.imgur.com/CpQZ1hr.png",
        email: "tkarfet@kiit.ac.in",
        linkedin: "https://www.linkedin.com/in/tejaswini-kar-381bb71b5/",
    },
];
